import { Component, OnInit, OnDestroy } from '@angular/core';
import { NodeService } from '../../services/node-service/node-service.service';
import { SubcategoryService } from '../subcategory/subcategory.service';
import { Subscription } from 'rxjs';
import { RootcategoriesService } from '../rootcategories/rootcategories.service';

export interface FormData {
  parentId: number;
}

@Component({
  selector: 'app-view-add-category',
  templateUrl: './view-add-category.component.html',
  standalone: false,
})
export class ViewAddCategoryComponent implements OnInit, OnDestroy {
  title: string = 'Agregar categoría';
  parentCaregory!: number;
  subscription!: Subscription;
  parentCategory: any;

  constructor(
    private nodeService: NodeService,
    private subcategoryService: SubcategoryService,
    private rootcategoriesService: RootcategoriesService
  ) {}

  ngOnInit(): void {
    this.parentCaregory = this.nodeService.getCategoryId();
    this.parentCategory = this.nodeService
      .getCategories()
      .filter((category) => category.id === this.parentCaregory)[0];

    if (!this.parentCategory) {
      this.subscription = this.subcategoryService.getCategory(this.parentCaregory).subscribe({
        next: () => {
          this.parentCategory = this.nodeService.getParentSelected();
          this.title = `Agregar categoría a ${this.parentCategory.nombre}`;
        },
        error: () => {
          this.rootcategoriesService.openSnacBar(
            'Ha ocurrido un error al buscar el Parent ID. Asegurese de que existe.'
          );
        },
      });
    }
    if (this.parentCategory) {
      this.title = `Agregar categoría a ${this.parentCategory.nombre}`;
    }
  }
  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }
}
